export default __webpack_public_path__ + "02c60d4d12e451134c96693faa1cdcfc.png";